import { Link, createFileRoute } from '@tanstack/react-router';
import { ArrowRight, FileUp, Route as RouteIcon } from 'lucide-react';
import { PageHeader } from '@/components/page-header';
import { IMPORT_TYPES } from '@/lib/imports';

export const Route = createFileRoute('/settings/import/')({ component: ImportData });

/** Wizards from document 12 that live with the move from QuickBooks and with banking. */
const MORE = [
  {
    title: 'Opening balances',
    description: 'The trial balance on your start date, mapped to your accounts.',
    to: '/settings/migration/opening-balances',
  },
  {
    title: 'Open invoices',
    description: 'Invoices and credits customers still owe at your start date.',
    to: '/settings/migration/open-items/receivable',
  },
  {
    title: 'Unpaid bills',
    description: 'Bills and debit notes still open with vendors at your start date.',
    to: '/settings/migration/open-items/payable',
  },
  {
    title: 'Bank statement',
    description: 'CSV or OFX statement lines.',
    to: '/banking/import',
  },
] as const;

/** Screen G4 (document 06): Settings › Import data. */
function ImportData() {
  return (
    <>
      <PageHeader
        title="Import data"
        description="Bring lists in from a CSV file, such as a QuickBooks export or one of our sample files."
      />
      <div className="flex max-w-4xl flex-col gap-4">
        <Link
          to="/settings/migration"
          className="flex items-center gap-3 rounded-lg border border-primary/30 bg-primary/5 p-4 hover:border-primary hover:shadow-sm"
        >
          <RouteIcon className="size-5 shrink-0 text-primary" />
          <div className="flex-1">
            <div className="font-medium">Move from QuickBooks</div>
            <div className="text-sm text-muted-foreground">
              A checklist that walks through every import in order, ties the open items to the
              opening trial balance and locks the books at the conversion date.
            </div>
          </div>
          <ArrowRight className="size-4 text-primary" />
        </Link>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {IMPORT_TYPES.map((t) => (
            <Link
              key={t.kind}
              to="/settings/import/$kind"
              params={{ kind: t.kind }}
              className="flex gap-3 rounded-lg border bg-card p-4 hover:border-primary hover:shadow-sm"
            >
              <FileUp className="mt-0.5 size-5 shrink-0 text-primary" />
              <div>
                <div className="font-medium">{t.title}</div>
                <div className="text-sm text-muted-foreground">{t.description}</div>
              </div>
            </Link>
          ))}
          {MORE.map((t) => (
            <Link
              key={t.title}
              to={t.to}
              className="flex gap-3 rounded-lg border bg-card p-4 hover:border-primary hover:shadow-sm"
            >
              <FileUp className="mt-0.5 size-5 shrink-0 text-primary" />
              <div>
                <div className="font-medium">{t.title}</div>
                <div className="text-sm text-muted-foreground">{t.description}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
